export enum PopupType {
    alert,
    confirm,
    success,
}
